import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

// ONE clear next action at the end of every major page (Restructure v0.2 rule:
// never five equally prominent buttons). Optional single secondary text link.
export const NextStepBand = ({ kicker = 'YOUR NEXT STEP', title, buttonLabel, to, external = false, secondaryLabel, secondaryTo, onClick, testId = 'next-step-band' }) => (
  <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-testid={testId}>
    <div className="bg-[#1a2744] rounded-2xl p-6 sm:p-10 text-center">
      <p className="text-xs font-black uppercase tracking-widest text-[#C9A84C]">{kicker}</p>
      <p className="mt-2 font-serif font-black text-white text-xl sm:text-2xl leading-snug">{title}</p>
      <div className="mt-5 flex justify-center">
        {onClick ? (
          <Button onClick={onClick} className="h-13 min-h-[52px] px-8 bg-[#C9A84C] hover:bg-[#b8973f] text-[#1a2744] text-base font-black btn-press" data-testid={`${testId}-button`}>
            {buttonLabel} <ArrowRight className="h-5 w-5 ml-1.5" />
          </Button>
        ) : external ? (
          <Button asChild className="h-13 min-h-[52px] px-8 bg-[#C9A84C] hover:bg-[#b8973f] text-[#1a2744] text-base font-black btn-press" data-testid={`${testId}-button`}>
            <a href={to} target="_blank" rel="noopener noreferrer">{buttonLabel} <ArrowRight className="h-5 w-5 ml-1.5" /></a>
          </Button>
        ) : (
          <Button asChild className="h-13 min-h-[52px] px-8 bg-[#C9A84C] hover:bg-[#b8973f] text-[#1a2744] text-base font-black btn-press" data-testid={`${testId}-button`}>
            <Link to={to}>{buttonLabel} <ArrowRight className="h-5 w-5 ml-1.5" /></Link>
          </Button>
        )}
      </div>
      {secondaryLabel && secondaryTo && (
        <p className="mt-4">
          <Link to={secondaryTo} className="text-sm font-bold text-slate-300 underline decoration-[#C9A84C]/60 decoration-2 underline-offset-4 hover:text-white" data-testid={`${testId}-secondary`}>{secondaryLabel}</Link>
        </p>
      )}
    </div>
  </section>
);
